<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo /> -->
        <div class="brand-text text-primary ml-1 nav navbar-nav flex-row d-flex align-items-center">
          <div class="mx-1">
            <b-img width="200" height="200" fluid :src="universityData && universityData.big_icon" alt="logo"/>
            <!-- <b-img width="40" height="40" fluid :src="logo" alt="logo" /> -->
          </div>

        </div>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <!-- <b-col v-bind:style="{ backgroundImage: 'url(' + imgUrl + ')' }" lg="8" class="d-none d-lg-flex align-items-center p-5 cover"> -->
      <b-col v-bind:style="universityData && universityData.background ? { backgroundImage: 'url(' +  universityData.background + ')' }:''" lg="8"
             class="d-none d-lg-flex align-items-center p-5 cover">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <!-- <b-img fluid :src="imgUrl" alt="Login V2" /> -->
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
            <div class="m-0 brand-text text-primary nav navbar-nav flex-row d-flex align-items-center">
              <!--             <h4 class="m-0 brand-text"> Welcome to </h4>-->
              <!--              <div class="mx-1">-->
              <!--                <b-img width="30" height="30" fluid :src="appLogoImage" alt="logo" />-->
              <!--              </div>-->
              <h4 class="m-0 brand-text">
                <!--                {{ appName }}-->
                {{ universityData && universityData.name }}
                <br/>
                Student Platform
              </h4>
            </div>
          </b-card-title
          >
          <!--          <b-card-text class="mb-2"> Please sign-in to your account and start the adventure</b-card-text>-->

          <!-- form -->
          <template v-if="!forceLogin">
            <validation-observer ref="loginForm" #default="{ invalid }">
              <b-form class="auth-login-form mt-2" @submit.prevent="login">
                <!-- email -->
                <b-form-group label="ID Number / Email" label-for="login-email">
                  <validation-provider #default="{ errors }" name="Email" vid="email" rules="required">
                    <b-form-input trim id="login-email" v-model="loginForm.email"
                                  :state="errors.length > 0 ? false : null" name="login-email"
                                  placeholder="john@example.com"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- forgot password -->
                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-password">Password</label>
                    <!-- <b-link :to="{ name: 'auth-forgot-password' }">
                                        <small>Forgot Password?</small>
                                      </b-link> -->
                  </div>
                  <validation-provider #default="{ errors }" name="Password" vid="password" rules="required">
                    <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                      <b-form-input id="login-password" v-model="loginForm.password"
                                    :state="errors.length > 0 ? false : null" class="form-control-merge"
                                    :type="passwordFieldType" name="login-password" placeholder="Password"/>
                      <b-input-group-append is-text>
                        <feather-icon class="cursor-pointer" :icon="passwordToggleIcon"
                                      @click="togglePasswordVisibility"/>
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- checkbox -->
                <!-- <b-form-group>
                  <b-form-checkbox id="remember-me" v-model="status" name="checkbox-1"> Remember Me </b-form-checkbox>
                </b-form-group> -->

                <!-- submit buttons -->
                <b-button :class="$store.state.app.load ? 'disabled_all' : ''" type="submit" variant="primary" block
                ><span v-if="!$store.state.app.load">{{ $t('Global.SignIn') }}</span>
                  <b-spinner v-if="$store.state.app.load" small :label="$t('Global.loading')"></b-spinner>
                </b-button>
                <b-button :class="$store.state.app.load ? 'disabled_all' : ''" type="button"
                          variant="outline-primary white" block
                          @click.prevent="msLoginUrl">
                  <span v-if="!$store.state.app.load"><img src="/ms-icon.png"
                                                           alt="">&nbsp; {{ $t('Global.SignInWithMicrosoft') }}</span>
                  <b-spinner v-if="$store.state.app.load" small :label="$t('Global.loading')"></b-spinner>
                </b-button>
                <p class="text-dark font-small-2 mt-1">
                  {{ $t('Global.loginHint') }}
                </p>
              </b-form>
            </validation-observer>
            <div class="pt-1" v-if="loginError">
              <b-alert
                  variant="danger"
                  :show="true"
                  class="mb-0"
              >
                <div class="alert-body">
                  <feather-icon
                      icon="InfoIcon"
                      class="mr-50"
                  />
                  {{ loginError }}
                </div>
              </b-alert>
            </div>
          </template>
          <template v-else>
            <b-button :class="'disabled_all'" type="button" variant="outline-primary white" block>
              <span><img src="/ms-icon.png" alt="">&nbsp; Signing you in ...&nbsp;</span>
              <b-spinner small :label="$t('Global.loading')"></b-spinner>
            </b-button>
          </template>

          <div class="divider my-2">
            <div class="divider-text"></div>
          </div>

          <div class="auth-footer-btn d-flex justify-content-center">
            <span class="small float-md-left d-block d-md-inline-block mt-25">
              {{ $t('Copyright') }}  © {{ new Date().getFullYear() }}
              <b-link
                  class="ml-25"
                  href=""
                  target="_blank"
              >{{ $t('Octopi') }}</b-link>
              , {{ $t('All rights Reserved') }}
            </span>
          </div>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import VuexyLogo from '@core/layouts/components/Logo.vue';
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BSpinner,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip
} from 'bootstrap-vue';
import useJwt from '@/auth/jwt/useJwt';
import {required, email} from '@validations';
import {togglePasswordVisibility} from '@core/mixins/ui/forms';
import store from '@/store/index';
import {getHomeRouteForLoggedInUser} from '@/auth/utils';
import {mapActions, mapGetters} from 'vuex';
import {$themeConfig} from '@themeConfig';

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
  },
  mixins: [togglePasswordVisibility],
  setup() {
    const {appName, appLogoImage} = $themeConfig.app;
    return {
      appName,
      appLogoImage,
    };
  },
  data() {
    return {
      status: '',
      forceLogin: false,
      loginForm: {
        email: '',
        password: '',
      },
      sideImg: require('@/assets/images/pages/bg2.jpg'),

      // validation rules
      required,
      email,
      loginError: false
    };
  },
  computed: {
    ...mapGetters({
      universityData: 'app/universityData'
    }),
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        this.sideImg = require('@/assets/images/pages/bg2.jpg');
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  mounted() {
    this.$store.dispatch('app/GET_UNIVERSITY_DATA')
    // Check if a token is present in the URL
    // if (this.$route.params.token) {
    //   this.handleTokenLogin(this.$route.params.token);
    // }
    // Check if there's a token in the URL
    const token = this.$route.query.token;
    if (token) {
      // Auto login using the token
      this.forceLogin = true;
      this.$store.dispatch('users/tokenLogin', { token })
          .then(success => {
            // Redirect to the dashboard upon successful login
            this.$router.replace({ name: 'dashboard' });
          })
          .catch((err) => {
            this.loginError = this.$t('Invalid token or login failed');
            this.forceLogin = false;
          });
    }
    if (this.$route.params.code !== undefined) {
      this.forceLogin = true;
      this.msLoginCallback({
        code: this.$route.params.code,
        session_state: this.$route.params.session_state,
        state: this.$route.params.state,
      });
    }
  },
  methods: {
    login: function () {
      this.$refs.loginForm
          .validate()
          .then(success => {
            if (success) {
              this.$store.dispatch('users/login', this.loginForm).then(() => {
                 if(this.authUser().id && this.authUser()?.type?.type == 4 && this.authUser()?.roles?.length == 0){
                  this.$router.replace({name: 'admissionForm',params:{type:this.authApplicant().applicant_type_id,id:this.authApplicant().id,secretKey:this.authApplicant().secret}});
                }else if (this.authUser().id) {
                  this.$router.replace({name: 'dashboard'});
                }
              }).catch((err) => {
                if(err?.response?.status == "500"){
                  this.loginError = this.$t('email or password is incorrect');
                }else{
                  this.loginError = this.$t(err?.response?.data?.errors[0]?.title);
                }
                
                
              });
            }
          })
          .catch(error => {
            this.$refs.loginForm.setErrors(error.response.data.error);
          });
    },
    msLoginUrl() {
      this.$store.dispatch('users/getMSLoginUrl').then(res => {
        return location.replace(res.data.url);
      });
    },
    msLoginCallback(payload) {
      this.$store.dispatch('users/msLoginCallback', payload).then(_ => {
        if (this.authUser().id) {
          this.$router.replace({name: 'dashboard'});
        }
      }).catch(_ => {
        this.forceLogin = false;
        this.$store.commit('app/UPDATE_LOAD', false);
        this.$refs.loginForm.setErrors(error.response.data.error);
      });
    },
    handleTokenLogin(token) {
      // Here you can dispatch a Vuex action or call an API to verify the token
      this.$store.dispatch('users/loginWithToken', token)
          .then(() => {
            // Redirect to dashboard or appropriate page after successful login
            this.$router.replace({ name: 'dashboard' });
          })
          .catch(error => {
            // Handle error (e.g., show an alert)
            this.loginError = this.$t('Invalid token. Please try again.');
          });
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
